import {Button} from '@mantine/core';
import {Alert} from 'src/design/atoms/Alert';
import {Group} from 'src/design/atoms/Group';
import {List} from 'src/design/atoms/List';
import {Text} from 'src/design/atoms/Text';
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {SectionTitle} from 'src/design/atoms/Typography';
import {NavAnchor} from 'src/design/atoms/NavAnchor';
import {ContentModal} from 'src/design/molecules/ContentModal';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {useConnectedWorkflows} from '../hooks/useConnectedWorkflows';
import {useNotificationRules} from '../hooks/useNotificationRules';

export const NotificationRulesAlert: React.FC = () => {
  const [showLinkedModulesModal, setShowLinkedModulesModal] = useState(false);
  const {notificationRules, hasActiveNotificationRules} =
    useNotificationRules();
  const {connectedWorkflows, hasConnectedWorkflows} = useConnectedWorkflows();

  if (!hasActiveNotificationRules && !hasConnectedWorkflows) return null;

  return (
    <>
      <Alert color="yellow" title="Connected Field">
        <Text mb="sm">
          This field is connected to other modules. Some settings cannot be
          edited.
        </Text>
        <Button size="sm" onClick={() => setShowLinkedModulesModal(true)}>
          More
        </Button>
      </Alert>
      <ContentModal
        title="Connected Modules"
        open={showLinkedModulesModal}
        onCloseCallback={() => setShowLinkedModulesModal(false)}>
        <Text mb="md">
          This field is connected to the following modules. Some properties of
          the field may not be edited unless these connections are removed. Use
          the links below to access the modules and remove the links if desired.
        </Text>
        {hasActiveNotificationRules && (
          <>
            <SectionTitle text="Notification Rules" />
            <List>
              {notificationRules.map(rule => (
                <List.Item key={rule.id}>
                  <Group>
                    <Text>{rule.name ?? rule.id}</Text>
                    <NavAnchor
                      component={Link}
                      to={PathUtility.NotificationRuleView(rule.id)}
                      target="_blank"
                      text="Open"
                    />
                  </Group>
                </List.Item>
              ))}
            </List>
          </>
        )}
        {hasConnectedWorkflows && (
          <>
            <SectionTitle text="Workflows" />
            <List>
              {connectedWorkflows.map(workflow => (
                <List.Item key={workflow.id}>
                  <Group>
                    <Text>
                      {workflow.name ??
                        workflow.internalIdentifier ??
                        workflow.id}
                    </Text>
                    <NavAnchor
                      component={Link}
                      to={PathUtility.WorkflowViewDefinition(
                        String(workflow.id)
                      )}
                      target="_blank"
                      text="Open"
                    />
                  </Group>
                </List.Item>
              ))}
            </List>
          </>
        )}
      </ContentModal>
    </>
  );
};
